"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  id: null,
  message: '',
  correlationId: null,
  authorId: null,
  updated: null,
  created: null,
  deletedAt: null,
  portalId: null,
  objectId: null,
  objectType: null,
  objectSubType: null,
  conversationId: null
};

var Comment = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Comment, _Record);

  function Comment() {
    (0, _classCallCheck2.default)(this, Comment);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Comment).apply(this, arguments));
  }

  (0, _createClass2.default)(Comment, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      return new Comment(data);
    }
  }]);
  return Comment;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Comment;
module.exports = exports.default;